// extracted by mini-css-extract-plugin
export var link = "_ux-0";